"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BottomSheet = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const helpers_1 = require("../../helpers");
const style_module_scss_1 = __importDefault(require("./style.module.scss"));
const Context_1 = require("../../Context");
const hooks_1 = require("../../hooks");
const ContentScroll_1 = __importDefault(require("../ContentScroll"));
;
const BottomSheet = (_a) => {
    var { onBackground, onClose, renderProps } = _a, props = __rest(_a, ["onBackground", "onClose", "renderProps"]);
    const { render, dialogStyle, bottomSheetSnapPoints, className, style, children, title } = props;
    const containerContext = (0, react_1.useContext)(Context_1.ContainerContext);
    const Styles = (0, hooks_1.useStyle)(style_module_scss_1.default, '_bottomsheet-');
    const [snapPoints, setSnapPoints] = (0, react_1.useState)([]);
    const sheetRef = (0, react_1.useRef)(null);
    const contentRef = (0, react_1.useRef)(null);
    const [position, setPosition] = (0, react_1.useState)(0);
    const startY = (0, react_1.useRef)(null);
    const endY = (0, react_1.useRef)(null);
    const lastPointIndex = (0, react_1.useRef)(-1);
    const currentPointIndex = (0, react_1.useMemo)(() => {
        const index = snapPoints.findIndex(v => parseFloat(v) === position);
        if (index >= 0 && lastPointIndex.current !== index) {
            lastPointIndex.current = index;
        }
        return lastPointIndex.current;
    }, [snapPoints, position]);
    const currentPoint = (0, react_1.useMemo)(() => snapPoints.at(currentPointIndex), [snapPoints, currentPointIndex]);
    const lastPoint = (0, react_1.useMemo)(() => { var _a; return (_a = snapPoints.at(-1)) !== null && _a !== void 0 ? _a : '50%'; }, [snapPoints]);
    const lastPointPosition = (0, react_1.useMemo)(() => parseFloat(lastPoint), [lastPoint]);
    const lastPointInt = (0, react_1.useMemo)(() => lastPointPosition / 100, [lastPointPosition]);
    const isLastPoint = (0, react_1.useMemo)(() => currentPoint === lastPoint, [currentPoint, lastPoint]);
    const isActiveContent = (0, react_1.useMemo)(() => Math.round(position) === lastPointPosition, [position, lastPointPosition]);
    const positionFooter = (0, react_1.useMemo)(() => (Math.abs(position - lastPointPosition) / 100) * window.innerHeight, [position, lastPointPosition]);
    const hide = () => {
        setPosition(0);
        renderProps.hide();
    };
    const getSnapIndex = (0, react_1.useCallback)((position, snapPoints) => {
        const pos = typeof position === 'string' ? parseFloat(position) : position;
        const snaps = snapPoints.map(p => parseFloat(p));
        if (snaps.length === 0)
            return -1;
        const firstHalf = snaps[0] / 1.5;
        if (pos < firstHalf)
            return -1;
        if (snaps.length === 1)
            return 0;
        for (let i = 1; i < snaps.length; i++) {
            const midpoint = (snaps[i - 1] + snaps[i]) / 2;
            if (pos < midpoint) {
                return i - 1;
            }
        }
        return snaps.length - 1;
    }, []);
    const handleTouchStart = (0, react_1.useCallback)((e) => {
        var _a;
        (_a = sheetRef.current) === null || _a === void 0 ? void 0 : _a.classList.add(style_module_scss_1.default['touch']);
        startY.current = e.touches[0].clientY;
        endY.current = position;
    }, [position]);
    const handleTouchMove = (0, react_1.useCallback)((e) => {
        if (startY.current === null || endY.current === null)
            return;
        const currentY = e.touches[0].clientY;
        const pos = Math.abs((((currentY - startY.current) / window.innerHeight) * 100) - endY.current);
        if (pos >= 100 || pos <= 0 || currentY > window.innerHeight)
            return;
        setPosition(pos > lastPointPosition ? lastPointPosition : pos);
    }, [startY.current, endY.current, lastPointPosition]);
    const handleTouchEnd = (0, react_1.useCallback)(() => {
        var _a;
        (_a = sheetRef.current) === null || _a === void 0 ? void 0 : _a.classList.remove(style_module_scss_1.default['touch']);
        const snapIndex = getSnapIndex(position, snapPoints);
        if (snapIndex >= 0) {
            const snapPoint = parseFloat(snapPoints[snapIndex]);
            setPosition(snapPoint);
        }
        else {
            hide();
        }
    }, [position, snapPoints]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (contentRef.current && (!bottomSheetSnapPoints || (bottomSheetSnapPoints && bottomSheetSnapPoints[0] === 'auto'))) {
            let autoSnap = (((_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) / window.innerHeight) * 100;
            autoSnap = autoSnap >= 100 ? 100 : autoSnap;
            setSnapPoints([`${autoSnap}%`]);
        }
        else {
            setSnapPoints(bottomSheetSnapPoints !== null && bottomSheetSnapPoints !== void 0 ? bottomSheetSnapPoints : ['50%']);
        }
    }, [bottomSheetSnapPoints]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (snapPoints.length > 0)
            setPosition(parseFloat((_a = snapPoints[0]) !== null && _a !== void 0 ? _a : 10));
    }, [snapPoints]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: (0, helpers_1.Style)('background'), onClick: hide }), (0, jsx_runtime_1.jsxs)("dialog", { className: Styles('bottomsheet-container'), tabIndex: 1, role: "dialog", style: Object.assign(Object.assign({}, dialogStyle), { transform: `translateY(${Math.abs(position - 100)}%)` }), ref: sheetRef, onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, onTouchEnd: handleTouchEnd, onTouchCancel: handleTouchEnd, open: true, children: [(0, jsx_runtime_1.jsx)("div", { className: Styles('bottomsheet-handle-container'), children: (0, jsx_runtime_1.jsx)("span", { className: Styles('bottomsheet-handle-indicator') }) }), typeof render === 'function' ? render(renderProps) :
                        (0, jsx_runtime_1.jsxs)("div", { className: Styles('bottomsheet') + (className ? ' ' + className : ''), style: Object.assign(Object.assign({}, style), { flexGrow: lastPointInt }), children: [(0, jsx_runtime_1.jsx)("header", { className: Styles('header'), children: (0, jsx_runtime_1.jsx)("div", { className: Styles('text'), children: title }) }), (0, jsx_runtime_1.jsx)(ContentScroll_1.default, { className: Styles('content'), active: isActiveContent, style: style, ref: contentRef, children: children }), containerContext.footer ? (0, jsx_runtime_1.jsx)("footer", { className: Styles('footer'), style: {
                                        transform: `translateY(-${positionFooter}px)`
                                    }, children: containerContext.footer }) : null] })] })] }));
};
exports.BottomSheet = BottomSheet;
